import { useEffect, useState } from "react";
import { useErrorContext } from "src/contexts/ErrorContext";
import { SvgIcon, Typography } from "@progress/kendo-react-common";
import { warningTriangleIcon } from "@progress/kendo-svg-icons";
import DialogBox from "../DialogBox/DialogBox";
import { ERROR_TOAST_MESSAGE, ERROR_403_MESSAGE } from "src/utils/constants";
import * as styles from "./ErrorFallbackDialog.css.ts";
import { useRouteError } from "react-router";

const ErrorTitle = () => (
  <p className={styles.errorHeading}>
    <SvgIcon icon={warningTriangleIcon} />
    Error
  </p>
);
const ErrorFallbackDialog = ({ message }: Record<string, string>) => {
  const [shouldShow, setShouldShow] = useState(false);
  const { errorMessage } = useErrorContext();
  const error = useRouteError();
  useEffect(() => {
    setShouldShow(true);
  }, []);

  return shouldShow ? (
    <DialogBox isOpen={shouldShow} title={<ErrorTitle />} closeIcon={false}>
      {(error as Error)?.message === ERROR_403_MESSAGE ? (
        <>
          <Typography.h4>{ERROR_403_MESSAGE}</Typography.h4>
          <Typography.p>
            Please contact your account manager to request access or update your
            permissions.
          </Typography.p>
        </>
      ) : (
        <>
          <p className={styles.errorParagraph}>
            {errorMessage || message || ERROR_TOAST_MESSAGE}
          </p>
          <ul className={styles.contactList}>
            <li>US: 1-888-826-3193 or ext: 20200</li>
            <li>International: 000-800-040-4315</li>
          </ul>
        </>
      )}
    </DialogBox>
  ) : null;
};

export default ErrorFallbackDialog;
